export const getAge = (birthday: Date) => {
   const today = new Date(BUtil.getCachedServerTime());
   let age = today.getFullYear() - birthday.getFullYear();
   const m = today.getMonth() - birthday.getMonth();
   if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
     age--;
   }
   return age;
};

export const getFlagUrl = (country: string, specialLocale?: string) => {
  if(specialLocale) {
    return '/images/membership/ticket.png';
  }
  return `/images/nation_flag/${country.toLowerCase()}.svg`;
};

type UserLocalTime = {
    hours: number;
    minutes: number;
    seconds: number;
    date: string;
    time: string;
    day: number;
    month: number;
    dayOrNight: 'day' | 'night';
    timeString: string;
};

export const getUserLocalTime = (tzoffset: number): UserLocalTime => {
  const myTZOffset = new Date().getTimezoneOffset();
  const nowms = Date.now();
  const utcms = nowms + myTZOffset * 60000;
  const localms = utcms - tzoffset * 60000;
  const localDT = new Date(localms);
  const hours = localDT.getHours();
  return {
    hours,
    minutes: localDT.getMinutes(),
    seconds: localDT.getSeconds(),
    date: localDT.toLocaleDateString(),
    time: localDT.toLocaleTimeString(),
    day: localDT.getDay(),
    month: localDT.getMonth() + 1,
    dayOrNight: hours > 18 || hours < 6 ? 'night' : 'day',
    timeString: new Date(localms).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }),
  };
};